<div class="important-msg-logo">
    <img src="../../assets/images/important-white-logo.svg" alt="" />
</div>